import { ReactNode } from "react";
import { PlaylistLocalStoragePersistence } from "../localStoragePersistence/v4/playlist/PlaylistLocalStoragePersistence";
import { Params, useParams } from "react-router-dom";
import { LinkOpeningProblemAlert } from "./LinkOpeningProblemAlert";

const playlistLocalStoragePersistence = new PlaylistLocalStoragePersistence();

interface Props {
  nodeExpectingPlaylistIdentifier: (playlistIdentifier: string) => ReactNode;
  isLocalStoragePersistenceValidationDisabled?: boolean;
}

export const playlistIdentifierParamKey = "playlistIdentifier";

export function ParamValidatorPlaylistIdentifier(props: Props) {
  const params: Readonly<Params<string>> = useParams();

  const optionalPlaylistIdentifier = params[playlistIdentifierParamKey];

  function validateAndRender(): ReactNode {
    if (optionalPlaylistIdentifier === undefined)
      return (
        <LinkOpeningProblemAlert>
          Der Identifier der Playlist fehlt.
        </LinkOpeningProblemAlert>
      );
    if (
      props.isLocalStoragePersistenceValidationDisabled !== true &&
      !playlistLocalStoragePersistence.doesDtoExist(optionalPlaylistIdentifier)
    )
      return (
        <LinkOpeningProblemAlert>
          Die gesuchte Playlist konnte lokal nicht gefunden werden.
        </LinkOpeningProblemAlert>
      );

    return props.nodeExpectingPlaylistIdentifier(optionalPlaylistIdentifier);
  }

  return validateAndRender();
}
